import { Injectable } from '@angular/core';
import { AuthService } from '@core/services/auth.service';
import { Router } from '@angular/router';
import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpHeaderResponse,
  HttpHeaders,
  HttpProgressEvent,
  HttpRequest,
  HttpResponse,
  HttpSentEvent,
  HttpUserEvent
} from '@angular/common/http';
import { catchError, Observable, throwError } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AuthInterceptorService {

  private authHeader = 'Authorization';

  constructor(
    private authService: AuthService,
    private router: Router
  ) {
  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const token = this.authService.getAuthToken();

    if (!token) {
      if (
        req.url.includes('authenticate') ||
        req.url.includes('assets') ||
        req.url.includes('2fa') ||
        req.url.includes('create-password') ||
        req.url.includes('verify-recovery-code')) {
        return next.handle(req).pipe(
          catchError((err: HttpErrorResponse): Observable<never> => {
            return throwError(err);
          })
        );
      }
    }

    req = this.appendToken(req, token);

    return next.handle(req).pipe(
      catchError((err: HttpErrorResponse): Observable<HttpSentEvent | HttpHeaderResponse | HttpResponse<any> | HttpProgressEvent | HttpUserEvent<any>> => {
        if (err && err.status === 401) {
          this.router.navigate(['login']).then();
        }
        return throwError(err);
      })
    );
  }

  private appendToken(request: HttpRequest<any>, token: string | any): HttpRequest<HttpHeaders> {
    return request.clone({
      headers: request.headers.set(this.authHeader, `Bearer ${token}`)
    });
  }
}
